import Alpine from "../alpine.js"
import { client } from "../client.js"

Alpine.data('postCommentDeletion', (commentId) => ({
  open: false,
  commentId,
  submitDelete ($event) {
    console.log($event)
    $event.target.setAttribute("disabled", "")
    client.delete(`/post_comments/${this.commentId}`)
      .then(() => { Turbo.visit(window.location.href) })
      .catch((error) => {
        console.log(error)
        $event.target.removeAttribute("disabled", "")
      })
  }
}))
